import React from 'react';
import classNames from 'classnames';
import { useButtonStyles } from '../Button/button.styles';
import { useButtonLinkStyles } from './buttonLink.styles';
function ButtonLink({ className, children, to }) {
    const buttonClasses = useButtonStyles({ margin: true });
    const classes = useButtonLinkStyles();
    return (React.createElement("a", { className: classNames(className, buttonClasses.button, buttonClasses.primary, buttonClasses.medium, buttonClasses.default, classes.root), href: to, target: "_blank", rel: "noreferrer" }, children));
}
export default ButtonLink;
//# sourceMappingURL=ButtonLink.js.map